import { useState } from 'react';
import { EyeCloseIcon, EyeOpenIcon } from '../../components/Shared/Icons';
import './input.css';

function getClassName({
  value,
  error,
  className,
}) {
  let newClassNames = '';
  if (!className) {
    newClassNames = `Input`;
  } else {
    newClassNames = `Input ${className}`;
  }
  if (value && value.length > 0) {
    newClassNames = `Input Input--completed`;
  }
  if (error && error.length) {
    newClassNames = `Input Input--error`;
  }
  if (className && className.length) {
    newClassNames = `${newClassNames} ${className}`
  }
  return newClassNames
}

function PasswordInput(props) {
  const [showPassword, setShowPassword] = useState(false);
  if (showPassword) {
    return (
      <TextInput
        {...props}
        type='text'
        renderIcon={() =>
          <div className='InputIcon' onClick={() => setShowPassword(false)}>
            <EyeOpenIcon />
          </div>
        }
      />
    )
  }

  return (
    <TextInput
      {...props}
      type='password'
      renderIcon={() =>
        <div className='InputIcon' onClick={() => setShowPassword(true)}>
          <EyeCloseIcon />
        </div>
      }
    />
  )
}

function labelName(label, name) {
  if (label) return label;

  if (!name) {
    return "Add name field";
  }
  
  let formattedName = name.replace(/^\w/, (l) => l.toUpperCase())
  return formattedName.replaceAll('_', ' ')
}

function TextInput(props) {
  const {
    id,
    name,
    type = 'text',
    label,
    error,
    renderIcon,
    placeholder,
  } = props;

  function renderInput() {
    return (
      <input
        {...props}
        id={id}
        name={name}
        type={type}
        placeholder={placeholder || name}
        className={getClassName(props)}
      />
    )
  }

  function renderInputContainerClassName() {
    if (error && error.length > 0)
      return "InputContainer InputContainerError";
    return "InputContainer"
  }
 
  return (
    <div className={renderInputContainerClassName()}>
      <label
        htmlFor={name}
        className='InputLabel'
      >
        {labelName(label, name)}
      </label>
      {renderInput()}
      {renderIcon && renderIcon()}
      {error && error.length &&
        <span className='InputErrorMessage'>
          {error}
        </span>
      }
    </div>
  )
}

function Input(props) {
  switch (props.type) {
    case 'password':
      return <PasswordInput {...props} />
    default:
      return <TextInput {...props} />
  }
}

export { Input };
